<p>sso-redirect works!</p>
